module.exports = __webpack_public_path__ + "img/2.d54165a6.png";